var _excluded = ["icon", "image", "iconPosition", "iconAlign", "sizeSpace", "emphasis", "text", "typography", "textEmphasis", "color", "textHoverColor", "iconHoverColor", "gutterSpace", "to", "href", "title", "openInNewTab", "onClick", "rel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import isNotEmpty from "../../../utils/isNotEmpty";
import IconAtm from "../IconAtm";
import { StyledIconLinkAtm, Text } from "./IconLinkAtm.styled";
export var defaultProps = {
  iconPosition: "right",
  iconAlign: "baseline",
  emphasis: "high",
  typography: "nano2_u",
  textEmphasis: "high",
  gutterSpace: 0.5
};
function IconLinkAtm(_ref) {
  var icon = _ref.icon,
    image = _ref.image,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? defaultProps.iconPosition : _ref$iconPosition,
    _ref$iconAlign = _ref.iconAlign,
    iconAlign = _ref$iconAlign === void 0 ? defaultProps.iconAlign : _ref$iconAlign,
    sizeSpace = _ref.sizeSpace,
    _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? defaultProps.emphasis : _ref$emphasis,
    text = _ref.text,
    _ref$typography = _ref.typography,
    typography = _ref$typography === void 0 ? defaultProps.typography : _ref$typography,
    _ref$textEmphasis = _ref.textEmphasis,
    textEmphasis = _ref$textEmphasis === void 0 ? defaultProps.textEmphasis : _ref$textEmphasis,
    color = _ref.color,
    textHoverColor = _ref.textHoverColor,
    iconHoverColor = _ref.iconHoverColor,
    _ref$gutterSpace = _ref.gutterSpace,
    gutterSpace = _ref$gutterSpace === void 0 ? defaultProps.gutterSpace : _ref$gutterSpace,
    to = _ref.to,
    href = _ref.href,
    title = _ref.title,
    openInNewTab = _ref.openInNewTab,
    onClick = _ref.onClick,
    rel = _ref.rel,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledIconLinkAtm, _extends({
    to: to,
    href: href,
    title: title,
    openInNewTab: openInNewTab,
    onClick: onClick,
    rel: rel,
    $emphasis: emphasis,
    $hasText: !!text,
    $textEmphasis: textEmphasis,
    $textHoverColor: textHoverColor,
    $iconHoverColor: iconHoverColor,
    $iconAlign: iconAlign,
    $onColor: onColor
  }, restProps), text ? /*#__PURE__*/React.createElement(Text, {
    $typography: typography,
    $textEmphasis: textEmphasis,
    $gutterSpace: gutterSpace,
    $iconPosition: iconPosition,
    $onColor: onColor,
    $color: color
  }, text) : null, isNotEmpty(icon) ? /*#__PURE__*/React.createElement(IconAtm, {
    icon: icon,
    sizeSpace: sizeSpace,
    emphasis: emphasis,
    color: color
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, image));
}
export default IconLinkAtm;